export const ReturnIcon = () => {
    return (
        <svg
            xmlns="http://www.w3.org/2000/svg"
            width="18"
            height="18"
            viewBox="0 0 18 18"
            fill="none"
        >
            <path
                d="M9 11.8145L11.8125 9.00195M11.8125 9.00195L9 6.18945M11.8125 9.00195L1.5 9.00195M1.5 4.31445V2.43945C1.5 1.92169 1.91973 1.50195 2.4375 1.50195H15.5625C16.0803 1.50195 16.5 1.92169 16.5 2.43945V15.5645C16.5 16.0822 16.0803 16.502 15.5625 16.502H2.4375C1.91973 16.502 1.5 16.0822 1.5 15.5645V13.6895"
                stroke="#040404"
                strokeWidth="1.5"
                strokeLinecap="round"
                strokeLinejoin="round"
            />
        </svg>
    )
}
